import { createFlyerDetailPageAssetsState } from "../types/flyer-detail-page-assets.functions";
import { FlyerDetailPageAssetsState } from "../types/flyer-detail-page-assets.interface";
import {
  FlyerDetailPageAssetsActions,
  FlyerDetailPageAssetsActionType,
} from "./flyer-detail-page-assets.actions";

export function flyerDetailPageAssetsReducer(
  state = createFlyerDetailPageAssetsState(),
  action: FlyerDetailPageAssetsActionType
): FlyerDetailPageAssetsState {
  switch (action.type) {
    case FlyerDetailPageAssetsActions.FetchPageAssets:
    case FlyerDetailPageAssetsActions.UploadPageAssets:
      return {
        ...state,
        isLoading: true,
      };

    case FlyerDetailPageAssetsActions.FetchPageAssetsFailure:
    case FlyerDetailPageAssetsActions.UploadPageAssetsFailure:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case FlyerDetailPageAssetsActions.FetchPageAssetsSuccess:
    case FlyerDetailPageAssetsActions.UploadPageAssetsSuccess:
      return {
        ...state,
        isLoading: false,
      };

    case FlyerDetailPageAssetsActions.ResetPageAssets:
      return createFlyerDetailPageAssetsState();

    case FlyerDetailPageAssetsActions.SetPageAssets:
      return {
        ...state,
        assets: action.payload,
      };

    default:
      return state;
  }
}
